import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LanguageLoader } from '../../assets/languages';

const Email = (props) =>
{
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [emails, SetEmails] = useState([{email_address:'', primary_address:false}]);
	const [firstLoad, SetFirstLoad] = useState(true);

	useEffect(() =>
	{
		if(props.defaultValue && props.defaultValue.length && firstLoad)
		{
			SetEmails(props.defaultValue);
			SetFirstLoad(false);
		}
	// eslint-disable-next-line
	}, [props]);

	useEffect(() =>
	{
		if(props.onChange)
		{
			let validEmails = Validation();
			props.onChange(validEmails);
		}
	// eslint-disable-next-line
	}, [emails]);

	const Validation = () =>
	{
		let validEmails = []; 
		if(emails.length !== 0)
		{
			for(const key in emails)
			{
				if(emails[key]['email_address'].trim() !== '')// && emails[key]['email_address'].trim().length > 5 && emails[key]['email_address'].indexOf('@') > -1)
				{
					validEmails.push(emails[key]);
				}
			}
		}
		return validEmails;
	}

	const HandleChange = (e, key) =>
	{
		const newEmailArray = [...emails];
		switch(e.target.type)
		{
			case "radio":
				for(const key in newEmailArray)
				{
					newEmailArray[key]['primary_address'] = '0';
				}
				newEmailArray[key]['primary_address'] = e.target.checked ? '1' : '0';
				break;
			case "text": newEmailArray[key]['email_address'] = e.target.value; break;
			default: return e;
		}
		SetEmails(newEmailArray);
	}

	const HandleDelete = (key) =>
	{
		const newEmailArray = [...emails];
		newEmailArray.splice(key,1)
		SetEmails(newEmailArray);
	}

	const AddEmail = () =>
	{
		const newEmailArray = [...emails];
		const email = {
			email_address: '',
			primary_address: false
		}
		newEmailArray.push(email);
		SetEmails(newEmailArray);
	}

	return <>
		{emails.map((email, index) => {
			return <div key={index} className='w-full flex mb-5 items-center'>
					<div className='me-3 cursor-pointer'>
						{index === 0 ? <i className="py-4 px-2 fa fa-plus fa-lg bg-primary text-white rounded-md" onClick={AddEmail}></i>
						: <i className='py-4 px-2 fa fa-trash-alt fa-lg text-danger rounded-md' onClick={()=>HandleDelete(index)}></i>}
					</div>
					<div className='grow'>
						<input type='text' value={email.email_address} onChange={(e)=>HandleChange(e, index)} />
					</div>
					<div className='flex items-center mx-2 gap-1'>
						<input type='radio' onChange={(e)=>HandleChange(e, index)} name='primary_address' checked={email.primary_address === '1'}/><span className='inline-block text-xs'>{language.PRIMARY}</span>
					</div>
				</div>
			})
		}
	</>
};

export default Email;